import {
  ACCESS_LEVELS,
} from '@/lib/consts.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export default {
  path: 'merge',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
    hintKey: 'hintFeatureClients',
  },
  component: () => import('@/views/business/customers/merge/index.vue'),
  children: [
    {
      path: 'create',
      name: 'merge-create',
      component: () => import('@/views/business/customers/merge/create.vue'),
    },
    {
      path: '',
      name: 'merge',
      component: () => import('@/views/business/customers/merge/list.vue'),
    },
  ],
}
